import { createContext, useContext } from "react";

interface ModifiedCellsContextValue {
  modifiedCells: Set<string>;
}

const ModifiedCellsContext = createContext<ModifiedCellsContextValue>({
  modifiedCells: new Set(),
});

export const ModifiedCellsProvider = ModifiedCellsContext.Provider;

/**
 * 수정된 셀인지 확인하는 훅
 * @param nurseId - 간호사 ID
 * @param dayIndex - 날짜 인덱스 (0-based)
 * @returns 해당 셀이 수정되었는지 여부
 */
export function useIsModifiedCell(
  nurseId: string,
  dayIndex: number
): boolean {
  const { modifiedCells } = useContext(ModifiedCellsContext);
  return modifiedCells.has(`${nurseId}-${dayIndex}`);
}

export default ModifiedCellsContext;
